import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await api.post("/login", { username, password });
      if (response.data.token) {
        onLogin(response.data.token);
      }
    } catch (error) {
      toast.error("Kullanıcı adı veya şifre hatalı!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center grain-bg px-4">
      <div className="w-full max-w-sm">
        <div className="bg-white/80 backdrop-blur-xl border border-[#E6E6E2] rounded-3xl p-8 shadow-sm">
          <div className="text-center mb-8">
            <div className="h-12 w-12 rounded-2xl bg-[#3B5249] flex items-center justify-center text-white font-semibold font-display mx-auto mb-4 text-xl">
              A
            </div>
            <h1 className="font-display font-semibold text-2xl text-[#1A1D1A]">
              Atölye Takip
            </h1>
            <p className="text-sm text-[#5C605C] mt-2">
              Lütfen giriş yapın
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-[#1A1D1A] mb-1.5">
                Kullanıcı Adı
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-4 py-2.5 rounded-xl border border-[#E6E6E2] bg-white/50 focus:outline-none focus:ring-2 focus:ring-[#3B5249]/20 focus:border-[#3B5249] transition-all"
                placeholder="Kullanıcı adınızı girin"
                required
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-[#1A1D1A] mb-1.5">
                Şifre
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2.5 rounded-xl border border-[#E6E6E2] bg-white/50 focus:outline-none focus:ring-2 focus:ring-[#3B5249]/20 focus:border-[#3B5249] transition-all"
                placeholder="••••••••"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#3B5249] hover:bg-[#2A3B34] text-white font-medium py-2.5 px-4 rounded-xl transition-colors mt-2 disabled:opacity-70"
            >
              {loading ? "Giriş Yapılıyor..." : "Giriş Yap"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
